import React, { PropTypes } from 'react'
import Avatar from '../../../Avatar'
import styles from './style.styl'

export default function SenderInfo(props) {
  const { displayName, orgName, sender } = props
  return (
    <div className={`${styles.SenderInfoWrapper} dsg-Body`}>
      <Avatar user={sender} size='medium'/>
      <div className={`${styles.SenderInfo} color-gray-dark`}>
        <div className='dsg-medium-weight'>{displayName}</div>
        <div className={styles.OrgName}>{orgName}</div>
      </div>
    </div>
  )
}
SenderInfo.propTypes = {
  displayName: PropTypes.string.isRequired,
  orgName: PropTypes.string.isRequired,
  // Passed to Avatar
  sender: PropTypes.object,
}



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/widget/TakeoverCampaign/SenderInfo/index.js